import React, { useState, useEffect } from 'react'
import { useParams, NavLink, Link } from 'react-router-dom';
import { COMPANY_URL, REQUEST_HEADERS } from '../../constants.js';
import CompanyCard from './CompanyCard.jsx';
import {
  Container,
  Alert,
  Navbar,
  NavbarBrand,
} from 'reactstrap';
import '../../assets/css/CompanyShareableCardStyle.css';
import cce_logo from '../../assets/images/cce_logo.png';
import axios from 'axios';

const CompanyShareableCard = () => {
  const { id } = useParams();
  const [isError, setIsError] = useState(false);
  const [companyData, setCompanyData] = useState(null);

  useEffect(() => {
    axios.get(
      `${COMPANY_URL}/${id}`,
      {
        headers: REQUEST_HEADERS
      })
      .then(res => {
        setCompanyData(res.data);
      }).catch(() => {
        setIsError(true);
      });
  }, [id]);

  return (
    <Container>
      <Navbar fixed="top" color="white" className="navbar-expand-lg card-box">
        <NavbarBrand className="mr-auto">
          <Link to="/company">
            <img
              alt={"CCE"}
              src={cce_logo}
              height={48} />
          </Link>
        </NavbarBrand>
        <NavLink to="/company" className="menu-link">Ir al Inicio</NavLink>
      </Navbar>
      {
        isError ? <Alert color="warning">Lo sentimos, este link es inválido</Alert>
          : null
      }
      {
        companyData != null && companyData.uuid === id
          ? <Container className="main-container">
              <CompanyCard
                data={companyData}
                showOpenInNewTab={false}
                renderCollapsed={false}/>
              <div className="after-card-text">
                Base de datos de empresas confiables respaldadas por
                &nbsp;
                <a href="https://www.cidemipymes.com.mx/#section-about" target="_blank" rel="noopener noreferrer">
                  CIDEMiPyMe
                </a>
                &nbsp;
                y
                &nbsp;
                <a href="https://www.cidemipymes.com.mx/#section-methodologies" target="_blank" rel="noopener noreferrer">
                  Círculo de Crecimiento Empresarial
                </a>
                &nbsp;
              </div>
            </Container>
          : null
      }
    </Container>
  );
}

export default CompanyShareableCard;